<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import Button from '../General/Button.vue';
import Heading from '../General/Heading.vue';
import { TEXT } from '../../configs/text';
import { useSessionStore, useSignalRStore } from '../../stores';
import { ClassGroupInfo, ClassSection } from '../../types/class';
import SetPoint from './SetPoint.vue';
import { utils } from '../../utils';

interface Props {
    group: ClassGroupInfo,
    sections: ClassSection[]
}
const { group, sections } = defineProps<Props>()
const emit = defineEmits<{ update: [] }>()

const sessionStore = useSessionStore()
const signalr = useSignalRStore()

const groupPoint = utils.calculateTotalPoint(group.bonus_point)
const groupTotalPoint = utils.calculateGroupTotalPoint(group)
const studentPoints = groupTotalPoint - groupPoint

function handlePointUpdate(updatePoint: number) {
    const pointToAdd = updatePoint - groupPoint
    const sectionItem = sections.find(sec => sec.section_code === sessionStore.currentSession)
    signalr.rewardPointGroup(group.id, pointToAdd, sessionStore.currentSession, sectionItem?.course_item_id || null)
    emit('update')
}

const { t } = useI18n()
</script>

<template>
    <Heading alignment="center">{{ t(TEXT.reward_point) }}</Heading>
    <div class="flex flex-wrap gap-3 items-center justify-center my-5">
        <Button color="info" :shadow="false" :border="false" class="font-normal text-sm min-w-32">
            <div>
                <div>{{ t(TEXT.point_student_total) }}</div>
                <div class="text-2xl font-bold">{{ studentPoints }}</div>
            </div>
        </Button>
        <Button color="info" :shadow="false" :border="false" class="font-normal text-sm min-w-32">
            <div>
                <div>{{ t(TEXT.point_group) }}</div>
                <div class="text-2xl font-bold">{{ groupPoint }}</div>
            </div>
        </Button>
        <Button color="info" :shadow="false" :border="false" class="font-normal text-sm min-w-32">
            <div>
                <div>{{ t(TEXT.point_group_total) }}</div>
                <div class="text-2xl font-bold">{{ groupTotalPoint }}</div>
            </div>
        </Button>
    </div>
    <div class="text-center mb-1">
        {{ t(TEXT.reward_point_for_group) }}
    </div>
    <div class="text-center font-bold text-xl">
        {{ group.name }}
    </div>
    <SetPoint :key="groupPoint" :point="groupPoint" @update="handlePointUpdate" />
</template>